import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Baseurl } from "../../config/BaseUrl";
import axios from "axios";

// Load initial state from localStorage
const loadAuthState = () => {
  try {
    const serializedState = localStorage.getItem('authState');
    if (serializedState === null) {
      return {
        mob: "",
        otp: "",
        partnermob: "",
        partnerOtp: "",
        isAuth: false,
        clientid: "",
        loginData: null,
        agentid: "",
        email: "",
        name: "",
        mobile: "",
        address: [],
        addressLoading: true,
        currentAddress: "",
        updateClientLoading: false,
        pageStatus: 0,
        selectedCarModels: [],
        currentCarModels: "",
        currentCar: "",
        carTotal: [],
        carTotalLoading: true,
        carModeltotal: [],
        carModelLoading: true,
        currentCarPageStatus: 0,
        isLoginModalOpen: false,
        isAddressModalOpen: false,
        loginMobile: "",
      };
    }
    const parsedState = JSON.parse(serializedState);
    return {
      ...parsedState,
      isLoginModalOpen: false, // Always reset modal state on page load
      isAddressModalOpen: false, // Always reset modal state on page load
      addressLoading: true,
      updateClientLoading: false,
      carTotalLoading: true,
      carModelLoading: true,
    };
  } catch (err) {
    console.error('Error loading auth state from localStorage:', err);
    return {
      mob: "",
      otp: "",
      partnermob: "",
      partnerOtp: "",
      isAuth: false,
      clientid: "",
      loginData: null,
      agentid: "",
      email: "",
      name: "",
      mobile: "",
      address: [],
      addressLoading: true,
      currentAddress: "",
      updateClientLoading: false,
      pageStatus: 0,
      selectedCarModels: [],
      currentCarModels: "",
      currentCar: "",
      carTotal: [],
      carTotalLoading: true,
      carModeltotal: [],
      carModelLoading: true,
      currentCarPageStatus: 0,
      isLoginModalOpen: false,
      isAddressModalOpen: false,
      loginMobile: "",
    };
  }
};

// Save state to localStorage
const saveAuthState = (state) => {
  try {
    const stateToSave = {
      isAuth: state.isAuth,
      loginData: state.loginData,
      clientid: state.clientid,
      email: state.email,
      name: state.name,
      mobile: state.mobile,
      address: state.address,
      currentAddress: state.currentAddress,
      // Don't save loading states or modal states
    };
    localStorage.setItem('authState', JSON.stringify(stateToSave));
  } catch (err) {
    console.error('Error saving auth state to localStorage:', err);
  }
};

const initialState = loadAuthState();

// Fixed loginAuthentication thunk
export const loginAuthentication = createAsyncThunk(
  "Authentication/loginAuthentication",
  async (formdetails, thunkAPI) => {
    try {
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/admin/sendsms`;
      
      console.log("Sending OTP request:", formdetails);
      
      const resp = await axios.post(url, formdetails, config);
      
      console.log("OTP response:", resp.data);
      
      if (resp.data.success) {
        return resp.data;
      } else {
        return thunkAPI.rejectWithValue(resp.data.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("OTP sending error:", error.response?.data || error.message);
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

// Other async thunks remain the same...
export const getcarManuf = createAsyncThunk(
  "Authentication/getcarManuf",
  async (thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/cars/all`;
      const resp = await axios(url);
      return resp.data.cars;
    } catch (error) {
      return thunkAPI.rejectWithValue("cars Not Found");
    }
  }
);

export const getcarModel = createAsyncThunk(
  "Authentication/getcarModel",
  async (thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/carModel/all`;
      const resp = await axios(url);
      return resp.data.carModels;
    } catch (error) {
      return thunkAPI.rejectWithValue("carModel Not Found");
    }
  }
);

export const addAddress = createAsyncThunk(
  "address/addaddress",
  async (formData, thunkAPI) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const url = `${Baseurl}/api/v1/client/address`;
      const resp = await axios.post(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Address not able to save");
    }
  }
);

export const clientUpdateById = createAsyncThunk(
  "Authentication/userUpdateById",
  async (formData, thunkAPI) => {
    try {
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/client/Clientid/${formData._id}`;
      const resp = await axios.put(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("User Not Updated");
    }
  }
);

const AuthenticationSlice = createSlice({
  name: "Authentication",
  initialState,
  reducers: {
    setLoginMobile(state, action) {
      state.loginMobile = action.payload;
    },
    SetLoginModalOpen(state, action) {
      state.isLoginModalOpen = action.payload;
    },
    SetAddressModalOpen(state, action) {
      state.isAddressModalOpen = action.payload;
    },
    SetEditAddressModalOpen(state, action) {
      state.isAddressModalOpen = action.payload;
    },
    LoginOtp(state, action) {
      state.mob = action.payload.number;
      state.otp = action.payload.OTP || action.payload.otp;
    },
    PartnerLoginOtp(state, action) {
      state.partnermob = action.payload.number;
      state.partnerOtp = action.payload.OTP;
    },
    setselectedCarModels(state, action) {
      state.selectedCarModels = [...state.selectedCarModels, action.payload];
    },
    setRemoveselectedCarModels(state, action) {
      state.selectedCarModels = [];
    },
    setcarTotal(state, action) {
      state.carTotal = action.payload;
    },
    setcarModeltotal(state, action) {
      state.carModeltotal = action.payload;
    },
    setCurrentCarPageStatus(state, action) {
      state.currentCarPageStatus = action.payload;
    },
    setcurrentCarModels(state, action) {
      state.currentCarModels = action.payload;
    },
    pageStatusChange(state, action) {
      state.pageStatus = action.payload;
    },
    signin(state, action) {
      state.isAuth = true;
      state.loginData = action.payload;
      state.clientid = action.payload._id;
      state.address = action.payload.Addresses || [];
      state.mobile = action.payload.Mobile;
      state.name = action.payload.Name || "";
      state.email = action.payload.Email || "";

      if (state.address.length >= 1 && !state.currentAddress) {
        state.currentAddress = state.address[0];
      }

      state.updateClientLoading = false;
      
      // Save to localStorage when user signs in
      saveAuthState(state);
    },
    signout(state, action) {
      state.isAuth = false;
      state.clientid = "";
      state.address = [];
      state.currentAddress = "";
      state.mob = "";
      state.otp = "";
      state.loginData = null;
      state.mobile = "";
      state.name = "";
      state.email = "";
      state.selectedCarModels = [];
      state.currentCarModels = "";
      
      // Clear from localStorage when user signs out
      localStorage.removeItem('authState');
    },
    updateAddress(state, action) {
      state.address = action.payload;
      // Save to localStorage when address is updated
      saveAuthState(state);
    },
    currAdress(state, action) {
      state.currentAddress = action.payload;
      // Save to localStorage when current address changes
      saveAuthState(state);
    },
    // Add a new action to clear only temporary states (like OTP) but keep auth
    clearTemporaryStates(state) {
      state.mob = "";
      state.otp = "";
      state.partnermob = "";
      state.partnerOtp = "";
      state.isLoginModalOpen = false;
      state.isAddressModalOpen = false;
      state.loginMobile = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // OTP sending cases
      .addCase(loginAuthentication.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(loginAuthentication.fulfilled, (state, action) => {
        state.isLoading = false;
        console.log("OTP sent successfully:", action.payload);
      })
      .addCase(loginAuthentication.rejected, (state, action) => {
        state.isLoading = false;
        console.error("OTP sending failed:", action.payload);
      })
      // Other cases remain the same...
      .addCase(getcarManuf.pending, (state) => {
        state.carTotalLoading = true;
      })
      .addCase(getcarManuf.fulfilled, (state, action) => {
        state.carTotalLoading = false;
        state.carTotal = action.payload;
      })
      .addCase(getcarManuf.rejected, (state) => {
        state.carTotalLoading = true;
      })
      .addCase(getcarModel.pending, (state) => {
        state.carModelLoading = true;
      })
      .addCase(getcarModel.fulfilled, (state, action) => {
        state.carModelLoading = false;
        state.carModeltotal = action.payload;
      })
      .addCase(getcarModel.rejected, (state) => {
        state.carModelLoading = true;
      })
      .addCase(addAddress.pending, (state) => {
        state.addressLoading = true;
      })
      .addCase(addAddress.fulfilled, (state, action) => {
        state.addressLoading = false;
        // If address was added successfully, update the local state
        if (action.payload.data) {
          state.address = [...state.address, action.payload.data];
          saveAuthState(state);
        }
      })
      .addCase(addAddress.rejected, (state) => {
        state.addressLoading = true;
      })
      .addCase(clientUpdateById.pending, (state) => {
        state.updateClientLoading = true;
      })
      .addCase(clientUpdateById.fulfilled, (state, action) => {
        state.updateClientLoading = false;
        if (action.payload?.data) {
          const updatedUser = {
            ...state.loginData,
            ...action.payload.data,
          };
          state.loginData = updatedUser;
          state.name = updatedUser?.Name || "";
          state.mobile = updatedUser?.Mobile || "";
          state.email = updatedUser?.Email || "";
          state.address = updatedUser?.Addresses || state.address;
          
          // Save updated user data to localStorage
          saveAuthState(state);
        }
      })
      .addCase(clientUpdateById.rejected, (state, action) => {
        state.updateClientLoading = false;
      });
  },
});

export const {
  LoginOtp,
  PartnerLoginOtp,
  pageStatusChange,
  signin,
  signout,
  updateAddress,
  currAdress,
  setselectedCarModels,
  setcurrentCarModels,
  setcarTotal,
  setcarModeltotal,
  setRemoveselectedCarModels,
  setCurrentCarPageStatus,
  SetLoginModalOpen,
  SetAddressModalOpen,
  SetEditAddressModalOpen,
  setLoginMobile,
  clearTemporaryStates,
} = AuthenticationSlice.actions;
export const authActions = AuthenticationSlice.actions;
export default AuthenticationSlice.reducer;